<template>
  <div>
    <dr-widget-list-component
      v-if="!isInEditorMode && isVisible"
      v-bind="$props"
      :class="evaluateClasses(classes)"
      @callDataSourceAction="$emit('callDataSourceAction', $event)"
    ></dr-widget-list-component>
    <dr-widget-list-editor
      v-else-if="isInEditorMode"
      v-on="wrapOn"
      v-bind="$props"
      :class="evaluateClasses(classes)"
      @modelChanged="$emit('modelChanged', $event)"
    ></dr-widget-list-editor>
  </div>
</template>

<script>
import mixin from '../../mixins/base-mixin'
import widgetsWrapperMixin from '../../mixins/widgets-wrapper-mixin'
import inputMixin from '../../mixins/input-mixin'
import drWidgetListEditor from './dr-widget-list-editor'
import drWidgetListComponent from './dr-widget-list-component'

export default {
  mixins: [mixin, inputMixin, widgetsWrapperMixin],
  components: {
    drWidgetListEditor,
    drWidgetListComponent
  }
}
</script>
